<template>
	<div class="profile-wrapper">
		<div class="title">积分明细</div>
		<div class="items" v-for="item in list">
			<div>
				<div class="name">{{item.name}}</div>
				<div class="date">{{item.date}}</div>
			</div>
			<div class="jifenNum"><span>{{item.type == 'add' ? '+' : '-'}}</span><span>{{item.num}}</span></div>
		</div>
	</div>
</template>

<script>

export default {
  data () {
    return {
      list:[{
		  name: '签到',
		  date: '2022-12-16 12:12:12',
		  num: 12,
		  type: 'add'
	  },
	  {
		  name: '每日任务',
		  date: '2022-12-16 12:12:12',
		  num: 10,
		  type: 'add'
	  },
	  {
		  name: '积分兑换',
		  date: '2022-12-16 12:12:12',
		  num: 120,
		  type: 'reduce'
	  }]
    }
  },
  methods: {
    
  },
  mounted () {
	  
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 10px;
	}
	.items{
		border-bottom: 1px solid #D4D4E6;
		padding: 10px 0;
		margin: 5px;
		&>div{
			display: inline-block;
		}
		.name{
			color: #383838;
			font-size: 16px;
			font-weight: 800;
			margin-bottom: 3px;
		}
		.date{
			color: #8B8B8B;
			font-size: 14px;
		}
		.jifenNum{
			float: right;
			color: #FF842E;
		}
	}
}	

</style>